import { Merchant } from "../../supplier/reporting/merchants/merchantTypes"
import React, { useState } from "react"
import { IconButton, TableCell, TableRow } from "@mui/material"
import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { faChevronDown, faChevronUp } from "@fortawesome/sharp-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MerchantTableRowDetails } from "./MerchantTableRowDetails"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    xs: {
        width: "2rem",
        padding: 0,
        textAlign: "center",
        verticalAlign: "middle",
    },
    s: {
        width: "5rem",
    },
    m: {
        width: "12rem",
    },
}))

export function MerchantTableRow({
    merchant,
    onMerchantClick,
    showDetailsRow,
}: {
    merchant: Merchant
    onMerchantClick?: (merchant: Merchant) => void
    showDetailsRow: boolean
}) {
    const [open, setOpen] = useState(false)
    const { classes } = useStyles()

    return (
        <React.Fragment key={merchant.id}>
            <TableRow onClick={() => onMerchantClick?.(merchant)}>
                {showDetailsRow && (
                    <TableCell className={classes.xs}>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={(event) => {
                                event.stopPropagation()
                                setOpen(!open)
                            }}
                        >
                            {open ? (
                                <FontAwesomeIcon size="xs" icon={faChevronUp} />
                            ) : (
                                <FontAwesomeIcon size="xs" icon={faChevronDown} />
                            )}
                        </IconButton>
                    </TableCell>
                )}
                <TableCell className={classes.s}>{merchant.caseNumber}</TableCell>
                <TableCell className={classes.m}>{merchant.name}</TableCell>
                <TableCell className={classes.m}>{merchant.addressDisplayText}</TableCell>
                <TableCell className={classes.xs}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </TableCell>
            </TableRow>
            {showDetailsRow && <MerchantTableRowDetails merchant={merchant} open={open} />}
        </React.Fragment>
    )
}
